export { default } from './ArrowFatUp'
